module.exports = __webpack_public_path__ + "img/Qian.772e6526.svg";